<template>
    <b-container fluid class="animated fadeIn">
        <h1>Pesquisar Cartas Emitidas e Emissão Individual</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div>
                        <b-card class="primary-semi p-2">
                            <b-row>
                                <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                    <b-form-group label="Nº da Dívida:" label-for="numeroDivida" class="text-label">
                                        <the-mask name="numeroDivida" class="form-control" v-model="filtro.numeroDivida"
                                            type="text" :mask="'############'" :masked="true" />
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                    <b-form-group label="Tipo de Carta:" label-for="tipoCarta" class="text-label">
                                        <template slot="label">
                                            Tipo de Carta:
                                            <i style="cursor: pointer;" class="fa fa-info-circle fa-12x text-info ml-2"
                                                @click="modalTipos()" variant="info">
                                            </i>
                                        </template>
                                        <multiselect v-model="filtro.tipoCarta" :show-labels="false"
                                            :options="dados.tiposCarta" :multiple="true" :close-on-select="false"
                                            :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                            :showNoResults="false" label="nome" track-by="id">
                                            <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                                    values.length }} selecionado(s)</span>
                                            </template>
                                        </multiselect>
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
                                        <the-mask id="cpfCnpj" class="form-control" v-model="filtro.cpfCnpj"
                                            :mask="['##.###.###/####-##', '###.###.###-##']" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="Data de Carta (Início):" label-for="dtCartaInicio"
                                        class="text-label">
                                        <b-form-input type="date" v-model="filtro.dtCartaInicio"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="Data de Carta (Fim)" label-for="dtCartaFim" class="text-label">
                                        <b-form-input type="date" v-model="filtro.dtCartaFim"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="Data de Cancelamento (Início):" label-for="dtCancelamentoInicio"
                                        class="text-label">
                                        <b-form-input type="date" v-model="filtro.dtCancelamentoInicio"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="Data de Cancelamento (Fim)" label-for="dtCancelamentoFim"
                                        class="text-label">
                                        <b-form-input type="date" v-model="filtro.dtCancelamentoFim"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row class="justify-content-center">
                                <div class="d-flex justify-content-between mb-3">
                                    <div>
                                        <b-button variant="primary" class="fonte-branca ml-2" @click="filtrar">
                                            <i class="fa fa-search"></i> Pesquisar
                                        </b-button>

                                        <a @click="consultarIncluir()">
                                            <b-button variant="primary" class="fonte-branca ml-2"
                                                :disabled="permitirInclusao()">
                                                <i class="fa fa-plus"></i> Incluir Carta
                                            </b-button>
                                            <i style="cursor: pointer;" class="fa fa-info-circle fa-12x text-info p-2"
                                                @click="modalTipos()" variant="info">
                                            </i>
                                        </a>

                                        <b-button variant="primary" class="fonte-branca ml-2" @click="exibirPdf"
                                            :disabled="selecteds.length == 0">
                                            <i class="fa fa-download"></i> Exibir
                                        </b-button>
                                        <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                            <i class="fa fa-eraser"></i> Limpar
                                        </b-button>
                                    </div>
                                </div>
                            </b-row>
                        </b-card>
                    </div>
                    <b-row class="mt-3" v-if="exibirGrid">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Dívidas Disponibilizadas - Quantidade: <strong>{{
                                                configTable.rows }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                    <CompTabelaEmitirCartasPesquisar :resultado="resultado" :fields="fields"
                                        :configTable="configTable" :selecteds="selecteds" @sortingChanged="consultarCartas"
                                        @consultarCartas="consultarCartas" />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <div class="d-flex justify-content-between mb-3">
                            <div>
                                <b-button class="mx-1" v-if="exibirGrid" variant="primary" :disabled="loadCSV"
                                    @click.prevent="exportCSV"><i class="fa fa-cloud-download" v-if="!loadCSV"></i>
                                    <b-spinner small v-if="loadCSV"></b-spinner>
                                    Exportar CSV
                                </b-button>
                                <b-button class="mx-1" variant="secondary" @click="voltar"><i class="fa fa-reply"></i>
                                    Voltar</b-button>
                            </div>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
            <b-modal ref="modalBry" size="lg" title="Modal Bry" cancel-title="Fechar">
                <Certificado :param="parametrosAssinatura" @finalizarAssinatura="processarArquivoAssinado($event)"
                    @erroAssinatura="processarErroAssinatura($event)" />
            </b-modal>
            <b-modal ref="modalTipos" size="lg" title="Tipos de Carta" ok-title="Fechar" ok-only>
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <span>
                            <label><strong>- RETIRADA:</strong> Tipo de carta para a situação de envio indevido. Condições
                                para a sua emissão: (i) CDA enviada à CRA e (ii) protesto ainda não lavrado pelo Tabelionato
                                (curso do tríduo legal) ou devolvido/recusado.</label>
                            <label><strong>- INDEVIDA:</strong> Tipo de carta para a situação de envio indevido. Condições
                                para a sua emissão: (i) CDA enviada à CRA e (ii) protesto já lavrado pelo Tabelionato (após
                                o decurso do tríduo legal) e não devolvido/recusado.</label>
                            <label><strong>- ANUÊNCIA:</strong> Tipo de carta para a situação de envio após o:
                                pagamento/parcelamento do principal e quitação dos honorários. Condições para a sua emissão:
                                (i) CDA enviada à CRA, (ii) protesto já lavrado pelo Tabelionato (após o decurso do tríduo
                                legal) e não devolvido/recusado e (iii) registro de pagamento/parcelamento do principal e
                                quitação dos honorários de protesto (existência de Requisição de Honorários de Protesto no
                                status quitada).</label>
                        </span>
                    </b-col>
                </b-row>
            </b-modal>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompPaginacao from './components/CompPaginacao'
import CompTabelaEmitirCartasPesquisar from './components/CompTabelaEmitirCartasPesquisar'
import Certificado from "assinador-bry";

export default {
    name: 'EmitirCartasPesquisar',
    components: {
        CompPaginacao,
        CompTabelaEmitirCartasPesquisar,
        Certificado,
    },
    data() {
        return {
            exibirGrid: false,
            filtro: {
                numeroDivida: null,
                cpfCnpj: null,
                tipoCarta: null,
                tipoCredito: null,
                dtCartaInicio: null,
                dtCartaFim: null,
                dtCancelamentoInicio: null,
                dtCancelamentoFim: null
            },
            dados: {
                creditos: [],
                tiposCarta: [],
                colunas: ['Número Dívida', 'Tipo de Carta', 'Justificativa', 'Data Carta', 'Data Cancelamento', 'Tipo Crédito', 'Origem', 'Procurador', 'Tabelionato', 'Prot. CRA', 'Devedor', 'Anexo']
            },
            parametrosAssinatura: {
                config: {
                    padraoAssinatura: "1"
                },
                ambiente: process.env.VUE_APP_BRY_AMBIENTE,
                arquivo: this.listaPdfsRetorno,
                token: JSON.parse(this.$store.getters.getUser).token.access_token,
                consumerId: 'PGEPROAJU',
                realizarDownloadArquivoAssinado: false
            },
            configTable: {
                perPage: 30,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false
            },
            showColunms: [],
            selecteds: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            resultado: [],
            listaPdfsRetorno: [],
            loadCSV: false
        }
    },
    watch: {
        perPage() {
            this.configTable.checkedAll = false
            this.selecteds = []
            this.configTable.currentPage = 1
            this.consultarCartas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        }
    },
    methods: {
        modalTipos() {
            this.$refs['modalTipos'].show();
        },
        verificarInclusao(sucesso) {
            if (sucesso) {
                this.$router.push({
                    name: 'EmitirCartasIncluir',
                    query: { numeroDivida: this.filtro.numeroDivida, cpfCnpj: this.filtro.cpfCnpj, tipoCredito: this.filtro.tipoCredito }
                });
            }
            // name: 'EmitirCartasIncluir'
            // query: {numeroDivida: filtro.numeroDivida, cpfCnpj: filtro.cpfCnpj, tipoCredito: filtro.tipoCredito}
        },

        /**
         * Consultar divídas
         */
        consultarIncluir() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = {
                numeroDivida: this.filtro.numeroDivida,
                cpfCnpj: this.filtro.cpfCnpj,
                tipoCredito: this.filtro.tipoCredito
            }

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if (this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/emitirCartasLote/consultarIncluir?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    if (response.data.rows == 0 || response.data.rows == null) {
                        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: [response.data.message] });
                        this.verificarInclusao(false);
                    } else {
                        this.verificarInclusao(true);
                    }
                }).finally(() => {
                    this.loadingExit()
                })
        },

        /**
         * Baixa o pdf do item selecionado
         */
        async exibirPdf() {
            if (this.selecteds.length != 0) {
                const urlApi = process.env.VUE_APP_ROOT_API
                const token = JSON.parse(this.$store.getters.getUser).token.access_token
                this.selecteds.forEach(registro => {
                    axios.post(`${urlApi}/v1/emitirCartasLote/obterPdfCartaExibir`, [registro], {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        },
                        responseType: 'arraybuffer'
                    })
                        .then(function (response) {
                            if (!response.data) {
                                this.$store.commit("setMessages", { message: 'Erro!', errors: ['PDF da carta não encontrado no servidor.'] });
                                return;
                            }
                            let blob = new Blob([response.data], { type: 'application/pdf' })
                            let link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = 'pdf-carta.pdf'
                            link.click()
                        }).finally(() => {
                            this.loadCSV = false
                        })
                });
            } else {
                this.$store.commit("setMessages", { message: 'Erro!', errors: ['Ao menos um registro deverá ser selecionado para exibição das cartas.'] });
            }
        },

        /**
         * Efetua o download do pdf a partir do response
         */
        downloadPdf(response) {
            if (!response.data) {
                this.$store.commit("setMessages", { message: 'Erro!', errors: ['PDF da carta não encontrado no servidor.'] });
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'pdf_carta.pdf');
            document.body.appendChild(link);
            link.click();
        },

        permitirInclusao() {
            if (this.filtro.numeroDivida || this.filtro.cpfCnpj) {
                return false;
            } else {
                return true;
            }
        },
        processarErroAssinatura(erro) {
            alert(erro)
        },
        processarArquivoAssinado(arquivosAssinadosB64) {
            //enviar arquivo servidor, realizar download.

            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/assinarCartasLote/finalizarAssinatura`, arquivosAssinadosB64, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(() => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Cartas(s) assinadas(s) com sucesso!'] });
                    this.selecteds = []
                })
                .catch(() => {
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro de comunicação ocorreu com um sistema externo, tente novamente mais tarde.'] });
                    this.selecteds = []
                })
                .finally(() => {
                    this.loadingExit()
                    this.consultarCartas()
                })

        },
        /**
        * Abre a modal BRY
        */
        show() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token
            axios.post(`${urlApi}/v1/assinarCartasLote/obterPdfsCartas`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(response => {
                    this.listaPdfsRetorno = response.data
                    this.parametrosAssinatura.arquivo = this.listaPdfsRetorno
                    this.$refs['modalBry'].show();
                }).finally(() => {
                    this.loadingExit()
                })
        },
        hide() {
            this.$refs['modalBry'].hide();
        },

        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                numeroDivida: null,
                cpfCnpj: null,
                credito: null,
                dtCartaInicio: null,
                dtCartaFim: null,
                dtCancelamentoInicio: null,
                dtCancelamentoFim: null
            }
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.selecteds = []
            this.consultarCartas()
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if (i == 0 || i == 2 || i == 3 || i == 4 || i == 6 || i == 7)
                return 'text-center justify-content-center'
            if (i == 5)
                return 'text-left justify-content-center'
            return 'justify-content-center'
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/dashboard');
        },


        /**
         * Consultar divídas
         */
        async consultarCartas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            this.exibirGrid = true;

            const filtro = {
                numeroDivida: this.filtro.numeroDivida,
                cpfCnpj: this.filtro.cpfCnpj,
                tipoCarta: this.filtro.tipoCarta,
                tipoCredito: this.filtro.tipoCredito,
                dtCartaInicio: this.filtro.dtCartaInicio,
                dtCartaFim: this.filtro.dtCartaFim,
                dtCancelamentoInicio: this.filtro.dtCancelamentoInicio,
                dtCancelamentoFim: this.filtro.dtCancelamentoFim
            }

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if (this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/emitirCartasLote/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    if (response.data.message) {
                        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: [response.data.message] });
                    } else {
                        this.resultado = response.data.resultado
                        if (this.configTable.perPage !== 'Todos') {
                            this.configTable.rows = response.data.rows
                        }

                        this.resultado.forEach(result => {
                            result.checked = false
                            this.selecteds.forEach(selected => {
                                if (result.codCarta == selected.codCarta) {
                                    result.checked = true
                                }
                            })
                        })
                    }
                }).finally(() => {
                    this.loadingExit()
                })
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/assinarCartasLote/listarTipoCredito`)
                .then(response => {
                    this.dados.creditos = response.data
                })
        },

        async listarTipoCarta() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/emitirCartasLote/listarTipoCarta`)
                .then(response => {
                    this.dados.tiposCarta = response.data
                })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async configurarColunas() {
            this.dados.colunas.forEach((field, i) => {
                this.showColunms.push(i + 1)
                this.fields.push({
                    key: `${i + 1}`,
                    label: `${field}`,
                    sortable: true,
                    sortDirection: "desc",
                    class: this.checkClassTable(i),
                    thClass: '',
                    tdClass: '',
                    codColunaFuncionalidade: i,
                    codFuncionalidade: i
                })
            })
        },
        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
            }
        },

        async exportCSV() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token

            this.loadCSV = true
            if (this.selecteds.length) {
                let selecionadas = []
                this.selecteds.forEach(carta => {
                    selecionadas.push({
                        codCarta: carta.codCarta
                    })
                })

                axios.post(`${urlApi}/v1/emitirCartasLote/exportarCsv`, selecionadas, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                    .then(response => {
                        this.downloadCSV(response)
                    }).finally(() => {
                        this.loadCSV = false
                    })
            } else {
                const filtro = {
                    numeroDivida: this.filtro.numeroDivida,
                    cpfCnpj: this.filtro.cpfCnpj,
                    tipoCarta: this.filtro.tipoCarta,
                    tipoCredito: this.filtro.tipoCredito,
                    dtCartaInicio: this.filtro.dtCartaInicio,
                    dtCartaFim: this.filtro.dtCartaFim,
                    dtCancelamentoInicio: this.filtro.dtCancelamentoInicio,
                    dtCancelamentoFim: this.filtro.dtCancelamentoFim
                }
                axios.post(`${urlApi}/v1/emitirCartasLote/exportarCsvTotal?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                    .then(response => {
                        this.downloadCSV(response)
                    }).finally(() => {
                        this.loadCSV = false
                    })
            }
        },

        downloadCSV(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'emitir-carta.csv');
            document.body.appendChild(link);
            link.click();
        },

    },
    mounted() {
        this.$store.commit("setMessages", {});

        this.configurarColunas()
        this.listarTipoCredito()
        this.listarTipoCarta()
    }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.fonte-branca {
    color: #FFF;
}

.fonte-branca:hover {
    color: #FFF;
}

.fonte-branca:active {
    color: #FFF !important;
}

.table-sub-item,
.table-sub-item>th,
.table-sub-item>td {
    background-color: rgb(237, 237, 238);
}

.font-red {
    color: red;
}</style>